webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
	baseUrl: 'https://zhuoqiu.xing-peng.com/index.php/api',

	imgDomain: '',

	uploadUrl: ''
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_swipe__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_swipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_swipeList__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_swipeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_swipeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_homeContent__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_homeContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_homeContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_footer__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shareContent__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shareContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_shareContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_aboutContent__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_aboutContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_aboutContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_downloadContent__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_downloadContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_downloadContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_jobContent__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_jobContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_jobContent__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        components: {
            header: __WEBPACK_IMPORTED_MODULE_2__components_header___default.a,
            swipe: __WEBPACK_IMPORTED_MODULE_3__components_swipe___default.a,
            swipeList: __WEBPACK_IMPORTED_MODULE_4__components_swipeList___default.a,
            homeContent: __WEBPACK_IMPORTED_MODULE_5__components_homeContent___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_6__components_footer___default.a
        },
        beforeEnter: function beforeEnter(to, from, next) {
            [].forEach.call(document.getElementsByTagName('li'), function (item) {
                item.className = '';
            });
            next();
        }
    }, {
        path: '/about',
        components: {
            header: __WEBPACK_IMPORTED_MODULE_2__components_header___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_6__components_footer___default.a,
            aboutContent: __WEBPACK_IMPORTED_MODULE_8__components_aboutContent___default.a
        }
    }, {
        path: '/share',
        components: {
            header: __WEBPACK_IMPORTED_MODULE_2__components_header___default.a,
            shareContent: __WEBPACK_IMPORTED_MODULE_7__components_shareContent___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_6__components_footer___default.a
        }
    }, {
        path: '/job',
        components: {
            header: __WEBPACK_IMPORTED_MODULE_2__components_header___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_6__components_footer___default.a,
            jobContent: __WEBPACK_IMPORTED_MODULE_10__components_jobContent___default.a
        }
    }, {
        path: '/download',
        components: {
            header: __WEBPACK_IMPORTED_MODULE_2__components_header___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_6__components_footer___default.a,
            downloadContent: __WEBPACK_IMPORTED_MODULE_9__components_downloadContent___default.a
        }
    }],
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        console.log(to, from, savedPosition);
        return { x: 0, y: 0 };
    },

    mode: 'history'
}));

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(136)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(164),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(58);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var docs = [{
	h3: '关于xx台球厅',
	p1: '这里不仅是球技切磋的竞技场，更是休闲放松的雅致空间。我们精心打造了一个集专业与娱乐',
	p2: '于一体的台球爱好者的梦幻之地，旨在为每一位踏入这里的您，带来无与伦比的击球体验与心灵享受。',
	p4: ''
}, {
	h3: '卓越台球殿堂',
	p1: '坐拥宽敞明亮的比赛级场馆，采用国际标准的绿色台球桌，每一张都经过严格调试，',
	p2: '确保桌面的平整与弹性的完美平衡，让每一次击球都能发挥出最佳状态。柔和而聚焦的照明设计，',
	p3: '不仅减少了视觉疲劳，更让球路的预判变得清晰无误，即便是细微的旋转与反弹也能尽收眼底子'
}];
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'shareContent',
	data: function data() {
		return {
			src: '/static/img/about.png',
			docs: docs
		};
	}
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var docs = [{
	src: '/static/img/steps1.jpg',
	h3: '<em>①</em>获取密码',
	p: '点击【马上用车】，<br>输入车牌号即可获得解锁密码'
}, {
	src: '/static/img/steps2.jpg',
	h3: '<em>②</em>拨轮锁开锁',
	p: '拨动密码盘，使密码对准锁身黄色标准线<br>按下圆形按钮，成功'
}, {
	src: '/static/img/steps3.jpg',
	h3: '<em>③</em>如何停放',
	p: '结束使用后，锁车、复位密码<br>将车停放至道路两旁安全、区域，方便他人取用'
}];
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'shareContent',
	data: function data() {
		return {
			src: '/static/img/download.jpg',
			docs: docs
		};
	}
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_config_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'header',
    data: function data() {
        return {
            src: '/static/img/footer_logo.png',
            code: ''
        };
    },
    created: function created() {
        this.getIndexData();
    },

    methods: {
        show: function show() {
            this.src = this.code;
        },
        hide: function hide() {
            this.src = '/static/img/footer_logo.png';
        },
        getIndexData: function getIndexData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__api_config_js__["a" /* default */].baseUrl + '/index/pc');

                            case 3:
                                response = _context.sent;

                                _this.code = response.data.data.code;
                                _context.next = 10;
                                break;

                            case 7:
                                _context.prev = 7;
                                _context.t0 = _context['catch'](0);

                                console.error('请求失败:', _context.t0);

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[0, 7]]);
            }))();
        }
    }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(32);


var navItems = [{
    text: '首页',
    link: '/'
}, {
    text: '关于我们',
    link: '/about'
}, {
    text: '联系我们',
    link: '/share'
}, {
    text: '招盟加商',
    link: '/job'
}];

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'header',
    data: function data() {
        return {
            navItems: navItems,
            navIn: 'nav-out'
        };
    },

    methods: {
        toLink: function toLink(link, $event) {
            [].forEach.call(document.getElementsByTagName('li'), function (item) {
                item.className = '';
            });
            $event.target.className = 'selected';
            __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push(link || '/');
        },
        addClass: function addClass($event) {
            if (!$event.target.className.match(new RegExp('(\\s|^)' + 'selected' + '(\\s|$)'))) {
                $event.target.className = ' ';
            }
            if (!$event.target.className.match(new RegExp('(\\s|^)' + 'nav-in' + '(\\s|$)'))) {
                $event.target.className += ' ' + 'nav-in';
            }
        },
        rmClass: function rmClass($event) {
            if (!$event.target.className.match(new RegExp('(\\s|^)' + 'selected' + '(\\s|$)'))) {
                $event.target.className = ' ';
            }
            if (!$event.target.className.match(new RegExp('(\\s|^)' + 'nav-out' + '(\\s|$)'))) {
                $event.target.className += ' ' + 'nav-out';
            }
        }
    }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_config_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'homeContent',
	data: function data() {
		return {
			src2: '',
			message: ''
		};
	},
	created: function created() {
		this.getIndexData();
	},

	methods: {
		getIndexData: function getIndexData() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var response;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								_context.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__api_config_js__["a" /* default */].baseUrl + '/index/pc');

							case 3:
								response = _context.sent;

								_this.src2 = response.data.data.about.image;
								_this.message = response.data.data.about.message;
								_context.next = 11;
								break;

							case 8:
								_context.prev = 8;
								_context.t0 = _context['catch'](0);

								console.error('请求失败:', _context.t0);

							case 11:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this, [[0, 8]]);
			}))();
		}
	}
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var docs = [{
	title: '产品设计',
	data1: '产品经理'
}, {
	title: '技术研发',
	data1: '后端工程师',
	data2: '硬件工程师',
	data3: '嵌入式软件工程师'
}, {
	title: '品牌公关',
	data1: 'PR经理'
}, {
	title: '市场运营',
	data1: '策略运营',
	data2: '用户运营'
}];
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'shareContent',
	data: function data() {
		return {
			src: '/static/img/job.png',
			docs: docs,
			src2: '/static/img/job2.png'
		};
	}
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'shareContent',
	data: function data() {
		return {
			src: '/static/img/share1.png',
			src2: '/static/img/concat.png'
		};
	}
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_config_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);







__webpack_require__(56);
var imgArr = [{
	src: '/static/img/home_bg5.png'
}];
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'swipe',
	components: {
		swiper: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__["swiper"],
		swiperSlide: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__["swiperSlide"]
	},
	data: function data() {
		return {
			swiperOption: {
				pagination: '.swiper-pagination',
				paginationClickable: true,
				autoplay: 5000
			},
			imgArr: []
		};
	},
	created: function created() {
		this.getIndexData();
	},

	methods: {
		getIndexData: function getIndexData() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var response;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								_context.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__api_config_js__["a" /* default */].baseUrl + '/index/pc');

							case 3:
								response = _context.sent;

								_this.imgArr = response.data.data.banners;
								console.log(response.data);
								_context.next = 11;
								break;

							case 8:
								_context.prev = 8;
								_context.t0 = _context['catch'](0);

								console.error('请求失败:', _context.t0);

							case 11:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this, [[0, 8]]);
			}))();
		}
	}
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_config_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);







__webpack_require__(56);
var imgArr = [{
	src: '/static/img/share_img1.png'
}, {
	src: '/static/img/share_img2.png'
}, {
	src: '/static/img/share_img3.png'
}, {
	src: '/static/img/share_img4.png'
}];
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'swipeList',
	components: {
		swiper: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__["swiper"],
		swiperSlide: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__["swiperSlide"]
	},
	data: function data() {
		return {
			swiperOption: {
				slidesPerView: 4,
				spaceBetween: 10
			},
			imgArr: []
		};
	},
	created: function created() {
		this.getIndexData();
	},

	methods: {
		getIndexData: function getIndexData() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var response;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								_context.next = 3;
								return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__api_config_js__["a" /* default */].baseUrl + '/index/pc');

							case 3:
								response = _context.sent;

								_this.imgArr = response.data.data.firm_images;
								_context.next = 10;
								break;

							case 7:
								_context.prev = 7;
								_context.t0 = _context['catch'](0);

								console.error('请求失败:', _context.t0);

							case 10:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this, [[0, 7]]);
			}))();
		}
	}
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(32);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(165),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(138)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(167),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(139)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(168),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(137)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(166),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(135)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(134)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(131)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(130)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(132)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(133)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pic mar1"
  }, [_c('img', {
    attrs: {
      "src": _vm.src2
    }
  }), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text mar1"
  }, [_c('p', [_vm._v("开放平台和共享精神")]), _vm._v(" "), _c('p', [_vm._v("接纳每一颗热衷共享的种子")]), _vm._v(" "), _c('p', [_vm._v("一同繁衍它的“城市大共享计划”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ad"
  }, [_c('h3', [_vm._v("联系我们")]), _vm._v(" "), _c('p', {
    staticClass: "word"
  }, [_vm._v("这里不仅是球技切磋的竞技场，更是休闲放松的雅致空间。")]), _vm._v(" "), _c('p', {
    staticClass: "word"
  }, [_vm._v("我们精心打造了一个集专业与娱乐于一体的台球爱好者的梦幻之地，旨在为每一位踏入这里的您，带来无与伦比的击球体验与心灵享受。")])])
}]}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "jobContainer"
  }, [_c('h3', [_vm._v("招商加盟")]), _vm._v(" "), _c('div', {
    staticClass: "desctxt"
  }, [_vm._v("\n                我们配备了全套高端台球器材，从经典木质球杆到现代科技复合材质，无论是初学者还是资深高手，都能在这里找到最适合自己的“武器”。更有专业教练团队驻场，提供一对一指导服务，无论是技巧提升、战术分析还是心理辅导，都能让您在短时间内实现球技的飞跃\n            ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.src2,
      "alt": ""
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    attrs: {
      "id": "jobH3"
    }
  }, [_vm._v("一些人等着被世界改变"), _c('br'), _vm._v("而我们已经在"), _c('br'), _vm._v("改变世界")])
}]}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipe"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.imgArr), function(item) {
    return _c('swiper-slide', {
      key: item
    }, [_c('img', {
      attrs: {
        "src": item
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.imgArr), function(item) {
    return _c('swiper-slide', {
      key: item
    }, [_c('img', {
      attrs: {
        "src": item
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mains"
  }, [_c('div', {
    staticClass: "pic mar1"
  }, [_c('div', {
    staticClass: "desc"
  }, [_c('h3', [_vm._v("关于我们")]), _vm._v(" "), _c('p', {
    staticClass: "word",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "imgs",
    attrs: {
      "src": _vm.src2
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "col",
    attrs: {
      "id": "nav"
    }
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/",
      "tag": "div"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('ul', _vm._l((_vm.navItems), function(item) {
    return _c('li', {
      on: {
        "mouseover": function($event) {
          return _vm.addClass($event)
        },
        "mouseleave": function($event) {
          return _vm.rmClass($event)
        },
        "click": function($event) {
          return _vm.toLink(item.link, $event)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                ")])
  }), 0)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "header"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "swipe"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "swipeList"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "homeContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "shareContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "aboutContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "downloadContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "jobContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "footer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearFloat"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "data"
  }, [_c('img', {
    attrs: {
      "src": _vm.src
    }
  }), _vm._v(" "), _c('p', [_vm._v("4001 507 507（周一至周日：7:00 - 24:00）")]), _vm._v(" "), _c('p', [_vm._v("北京市海淀区北四环西路58号理想国际大厦11层")])]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "wechat",
      "href": "javascript:;"
    },
    on: {
      "mouseover": _vm.show,
      "mouseleave": _vm.hide
    }
  })])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company"
  }, [_c('p', [_vm._v("Copyright © 2017 ofo Inc. 保留所有权利。京公网安备 11010802022978号   |   公共事务邮箱  gr@ofo.so    商务合作邮箱  bdinchina@ofo.so")])])
}]}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), _c('div', _vm._l((_vm.docs), function(item) {
    return _c('div', {
      staticClass: "mar"
    }, [_c('h3', [_vm._v(_vm._s(item.h3))]), _vm._v(" "), _c('p', {
      staticClass: "word"
    }, [_vm._v(_vm._s(item.p1))]), _vm._v(" "), _c('p', {
      staticClass: "word"
    }, [_vm._v(_vm._s(item.p2))]), _vm._v(" "), _c('p', {
      staticClass: "word"
    }, [_vm._v(_vm._s(item.p3))]), _vm._v(" "), _c('p', {
      staticClass: "word"
    }, [_vm._v(_vm._s(item.p4))])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    attrs: {
      "id": "about"
    }
  }, [_vm._v("“共创台球”模式"), _c('br'), _vm._v("一起畅玩")])
}]}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('h3', {
    attrs: {
      "id": "download"
    }
  }, [_vm._v("ofo 共享单车 APP")]), _vm._v(" "), _c('p', [_vm._v("全新 1.8 版本，邀您共享")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "teach"
  }, [_c('h3', [_vm._v("使用方法")]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, _vm._l((_vm.docs), function(item) {
    return _c('div', {
      staticClass: "container"
    }, [_c('img', {
      attrs: {
        "src": item.src
      }
    }), _vm._v(" "), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(item.h3)
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.p)
      }
    })])
  }), 0)])])
},staticRenderFns: []}

/***/ })
],[91]);


// WEBPACK FOOTER //
// static/js/app.ceb6608c46163d482bc0.js